import React from 'react';
import { DEV_PWA_SECURE_LOGIN_URL, isInsecureDevOrigin } from '../config/pwaDevConfig';
import './PwaHttpNotice.css';

/**
 * Shown on http://15.206.221.200:8888 — browsers block PWA install on HTTP.
 */
const PwaHttpNotice = () => {
  if (!isInsecureDevOrigin()) return null;

  return (
    <div className="pwa-http-notice" role="alert">
      <div className="pwa-http-notice__icon" aria-hidden="true">🔒</div>
      <div className="pwa-http-notice__body">
        <strong>Install app requires HTTPS</strong>
        <p>
          This page is <code>http://…:8888</code>. Chrome will not show &quot;Install app&quot; on HTTP.
          Use the secure dev link below (same app, valid certificate).
        </p>
        <a className="pwa-http-notice__link" href={DEV_PWA_SECURE_LOGIN_URL}>
          Open https://15-206-221-200.nip.io/login
        </a>
      </div>
    </div>
  );
};

export default PwaHttpNotice;
